import * as Sentry from "@sentry/react";
import { makeAutoObservable } from "mobx";
import { CustomError, ICustomError } from "./CustomError";

export class ErrorStack {
  private static instance: any;

  public errors: CustomError[] = [];

  private constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  add(error: CustomError) {
    this.errors.push(error);
  }

  clear(index: number = -1) {
    if (index >= 0) {
      this.errors.splice(index, 1);
    } else {
      this.errors.length = 0;
    }
  }

  public static createInstance() {
    return this.instance || (this.instance = new this());
  }

  static create({ title, message, severity, error }: ICustomError): CustomError {
    const customError = new CustomError(title, message, severity, error);
    errorStack.add(customError);
    Sentry.captureException(customError);
    return customError;
  }
}

// TODO: change this to ErrorStack.instance like axios does. Does ErrorStack become a namespace instead and we rename our class?
export const errorStack = ErrorStack.createInstance();
